import { useMemo } from "react";

import { useSelector } from "react-redux";

import { selectTriggerNode } from "Services/state/journeys/JourneyStateSlice";
import { NodeTriggerType } from "Types/Journey";
import { DynamicCondition } from "Types/Segment";

// TODO: GET RID OF THIS HOOK = THIS IS JUST MORE SELECTORS
// Investigate how this is used and how it can be removed.
export function useTriggerEventNode() {
    const triggerNode = useSelector(selectTriggerNode);
    const triggerNodedata = useMemo(() => {
        const firstGroupCondition = (triggerNode?.data.triggerFiltersEvents as DynamicCondition[])?.[0].conditions?.[0];
        return {
            eventType: firstGroupCondition?.conditionalType,
            eventName: firstGroupCondition?.eventName,
        };
    }, [triggerNode]);

    const isScheduledTrigger = triggerNodedata?.eventType === NodeTriggerType.Scheduled;

    return { triggerNode: triggerNodedata, isScheduledTrigger };
}
